import { render, staticRenderFns } from "./input-course.vue?vue&type=template&id=00bbaf08"
import script from "./input-course.vue?vue&type=script&lang=js"
export * from "./input-course.vue?vue&type=script&lang=js"
import style0 from "./input-course.vue?vue&type=style&index=0&id=00bbaf08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports